import {Recruitment, RecruitmentRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip} from "../../../../components/kit";
import {Typography} from "@mui/material";
import {RECRUITMENT_STATUS} from "../labels";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";
import {COLOR_GRIS} from "../../../../components/layout/colors";
import React, {useEffect, useState} from "react";


export const RecruitmentListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Recruitment> = {
		title: "Procesos de selección ",
		onClick: "/app/admin/recruitment/recruitment",
		headers: [
			{title: "Título"},
			{title: "Cliente"},
			{title: "Estado"},
			{title: "En la web"},
		],
		decorator: (bean: Recruitment) => (
			<>
				<TableCell style={{color: bean.status === "FINISHED" || bean.status === "DESISTED" ? COLOR_GRIS : ""}}>
					{bean.title}
				</TableCell>
				<TableCell>
					{bean.customer?.shortName}
				</TableCell>
				<TableCell>
					{bean.status ? <SoftChip tone={RECRUITMENT_STATUS[bean.status]?.tone ?? "neutral"} label={RECRUITMENT_STATUS[bean.status]?.label ?? bean.status}/> : "—"}
				</TableCell>
				<TableCell>
					{bean.visible ? <SoftChip tone="success" label="Publicado"/> : <Typography variant="body2" color="text.disabled">Oculto</Typography>}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(RecruitmentRestControllerApiFactory);
			return ctrl.pageRecruitment(currentPage, size, undefined, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};

export const useRecruitment = (id: number | undefined): [(Recruitment | undefined), React.Dispatch<React.SetStateAction<Recruitment | undefined>>] => {
	const apiManager = useApiManager();
	const [getter, setter] = useState<Recruitment | undefined>();
	const ctrl = apiManager.factory(RecruitmentRestControllerApiFactory);

	useEffect(() => {
		if (id) {
			apiManager
			.execute(ctrl.getRecruitment(id))
			.then(c => setter(c));

		}
	}, [id]);
	return [getter, setter];
};